import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Segment, Icon } from 'semantic-ui-react';
import { Box, Flex } from 'rebass';

class Error extends Component {
  static propTypes = {
    title: PropTypes.string,
  };
  static defaultProps = {
    title: 'มีข้อผิดพลาด กรุณารีเฟรชหน้านี้',
  };
  render() {
    const { title } = this.props;
    return (
      <Flex justifyContent="center" pt={2}>
        <Segment textAlign="center">
          <Box pt={1} pb={2}>
            <Icon name="warning sign" size="big" color="grey" />
          </Box>
          {title}
        </Segment>
      </Flex>
    );
  }
}

export default Error;
